import { CommonModule } from "@angular/common";
import { Component, signal, input } from "@angular/core";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [CommonModule]
})
export class FooterComponent {
  // Signal per la data corrente
  today = signal(new Date());

  isAuth = input<boolean>(false);
}

